/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */
import { useContext } from 'react';
import { ScreenShareSettingsContext } from '@/context/call-context/screen-share-context.tsx';

export const useScreenShareSettings = () => useContext(ScreenShareSettingsContext);
